import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentAnalysisRow } from '@features/dashboard/document-analysis/document-analysis.model';

@Component({
  selector: 'app-document-analysis-company-card',
  templateUrl: './document-analysis-company-card.component.html',
  styleUrls: ['./document-analysis-company-card.component.scss'],
  standalone: false,
})
export class DocumentAnalysisCompanyCardComponent {
  @Input({ required: true }) row!: DocumentAnalysisRow;

  @Output() analyze = new EventEmitter<string>();

  get pendingLabel(): string {
    return this.row.pendingDocuments === 1 ? 'documento aguardando' : 'documentos aguardando';
  }
}
